import Fooji from "@fooji/microsites";
import { setLoading, setPage, nextStep } from "../stores/route";
import { notify } from "./bugsnag";
import { isDemo } from "../stores/mode";

/**
 * Uploads a receipt image file
 * @param file - The file to upload
 * @returns Promise that resolves on success, rejects with error on failure
 */
export async function uploadReceipt(file: File): Promise<void> {
  setLoading(true);

  try {
    if (!isDemo()) {
      const fileKey = await Fooji.Upload.save(file);
      await Fooji.UserSettings.save({
        lc_cod_code: false,
        entry_token: false,
        file_upload: fileKey
      });
    }

    nextStep();
  } catch (error) {
    setLoading(false);
    
    const errorMessage = (error as Error)?.message;

    if (errorMessage?.endsWith("already exists!")) {
      setPage("error", "invalidEntry");
    }

    if (
      !errorMessage?.includes("File too large") &&
      !errorMessage?.endsWith("already exists!") &&
      !errorMessage?.includes("Invalid file type")
    ) {
      notify({ errorMessage: "Error uploading receipt", error });
      console.error(error);
    }

    // Re-throw so the caller can handle component-specific cleanup
    throw error;
  }
}

